import { prefix } from './prefix';

// 签名刷新事件名，其他模块在签名上传成功后触发这个事件。
const SIGNATURE_REFRESH_EVENT = 'lx-user-signature-refresh';

// 用时间戳作为缓存戳，拼到签名地址后面，强制浏览器重新拉取最新图片。
let signatureRefreshToken = 0;

/**
 * 主动通知全局签名需要刷新。
 * 常用于上传签名后调用。
 *
 * @returns 本次刷新生成的缓存戳
 */
function refreshUserSignature() {
  if (typeof window === 'undefined') {
    return 0;
  }

  // 每次刷新都更新缓存戳，并广播给监听签名的组件。
  signatureRefreshToken = Date.now();
  window.dispatchEvent(new CustomEvent(SIGNATURE_REFRESH_EVENT, {
    detail: signatureRefreshToken
  }));
  return signatureRefreshToken;
}

/**
 * 订阅签名刷新事件。
 * 一般由展示签名的组件调用，在收到事件后重新设置签名地址。
 *
 * @param callback 收到刷新通知后的回调，参数为最新缓存戳
 * @returns 取消订阅的方法
 */
function subscribeUserSignatureRefresh(callback) {
  if (typeof window === 'undefined') {
    return () => undefined;
  }
  const handleRefresh = event => {
    const customEvent = event;
    callback(customEvent.detail || signatureRefreshToken);
  };
  window.addEventListener(SIGNATURE_REFRESH_EVENT, handleRefresh);
  return () => {
    window.removeEventListener(SIGNATURE_REFRESH_EVENT, handleRefresh);
  };
}

/**
 * 生成用户签名访问地址。
 * 会自动追加缓存戳，避免浏览器命中旧签名缓存。
 *
 * @param userId 用户 ID
 * @param token 可选缓存戳，不传时使用当前全局缓存戳
 * @returns 可直接用于 img src 的签名地址；没有 userId 时返回空字符串
 */
function getUserSignatureUrl(userId, token) {
  if (!userId) {
    return '';
  }
  const cacheToken = token ?? signatureRefreshToken;
  const query = cacheToken ? `?t=${cacheToken}` : '';
  return `${prefix.iam}/signature/user/${userId}/signature${query}`;
}
export { SIGNATURE_REFRESH_EVENT, getUserSignatureUrl, refreshUserSignature, subscribeUserSignatureRefresh };